import qs from 'qs';
import axios from 'axios';
import { Toast } from 'vant';
import languages from '@store/languages';
import {
  getHrefParam,
  post,
  get,
  appendEntryPageParams,
  sliceFile,
  xhtPost,
  xhrPut,
  SUPPORT_REQ_URL,
  PASSPORT_HOST,
  HOME_HOST,
  getJSON,
  MAIN_HOST
} from '@store/ultile';
import sdkSkin from '@store/sdkSkin';
import formatAdapter from '@utiles/officialSupport/supportTextAdapter';
import globalConfig, { isJSON } from '@utiles/globalConfig';
import { encryption } from '@utiles';
import { getFingerprint } from '@utiles/fingerPrint';
import { getFileExtension } from '@utiles';
import { formatGameName, hex2bin } from '@utiles/officialSupport';
import { Base64 } from 'js-base64';
import { updateCommonParamsInfo } from '@plugins/biPoint/commonParam';
languages.init();
axios.defaults.withCredentials = true;

const CHECK_LOGIN_ACTION = 'center/ajax/get_user_json';

const getUrlParams = () => {
  return {
    uid: getHrefParam('uid'),
    loginAccount: getHrefParam('loginAccount'),
    gameId:
      getHrefParam('gameId') ||
      getHrefParam('gameID') ||
      getHrefParam('game_id'),
    serverId: getHrefParam('serverId'),
    roleId: getHrefParam('roleId'),
    roleName: getHrefParam('roleName'),
    isUidLogin: getHrefParam('isUidLogin'),
    packageVersion: getHrefParam('packageVersion'),
    e_info: getHrefParam('e_info'),
    gpid: getHrefParam('gpid'),
    idfa: getHrefParam('idfa'),
    packageName: getHrefParam('packageName'),
    discordId: getHrefParam('discordId') || getHrefParam('discord_id')
  };
};

/**
 * 获取context，同一个文件会返回相同的值
 * @param {*} file 文件对象
 * @returns
 */
const createContext = file => {
  return file.name + file.size;
};

const URL_PARAMS = getUrlParams();
export const SET_LANG = 'SET_LANG';
export const SET_IS_LOGIN = 'SET_IS_LOGIN';
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_RECORD_BIND_EMAIL = 'SET_RECORD_BIND_EMAIL';
export const SET_WORK_TEMP_LIST = 'setWorkTempList';
export const SET_FAQ_SITE_NAME = 'setFaqSiteName';
export const SET_FAQ_CLASS_LIST = 'setFaqClassList';
export const SET_FAQ_NOTICE = 'setFaqNotice';
export const SET_SUPPORT_LANG = 'setSupportLang';
export const SET_DEFAULT_LANG = 'setDefaultLang';
export const SET_JUMP_AIBOT = 'setJumpAiBot';
export const SET_LOGIN_ACCOUNT = 'setLoginAccount';
export const SET_IS_SPECIAL_DIFY_USER = 'setIsSpecialDifyUser';
export const SET_SHOW_UPDATE_VERSION_POPUP = 'setShowUpdateVersionPopup';
export default {
  strict: process.env.NODE_ENV !== 'production', // 在非生产环境下，使用严格模式
  state: {
    supportLang: {}, //后台配置的该游戏支持的语言
    defaultLang: '', // 后台配置的默认语言
    curLang: languages.getLanguage(), // 当前展示的语言
    langList: languages.getLangText(), // 语言下拉列表
    languages: formatAdapter(languages.getAll()), // 当前语言的文案
    urlParams: URL_PARAMS, // 链接参数的值
    isUidGame: globalConfig.isUidGame(),
    isLogin: false,
    userInfo: {
      gameName: '',
      serverName: '',
      roleName: ''
    },
    recordBindEmail: undefined, // 绑定的邮箱
    workTempList: [], // 工单模板列表
    faqSiteName: '', // faq站点名称
    faqClassList: [], // faq一级二级分类列表
    faqNotice: [], // 走马灯文章列表
    isIframe: globalConfig.getHrefParam('isIframe') == 1,
    isJumpAiBot: false,
    hideEmail: [371].includes(+URL_PARAMS.gameId), // 隐藏邮箱订阅的游戏
    loginAccount: '',
    isSpecialDifyUser: 0, // 是否为特殊dify用户，0否，1是
    showUpdateVersionPopup: false // 是否显示更新版本弹窗
  },
  getters: {
    canSelectGameInfo(state) {
      return !(
        state.urlParams.gameId &&
        state.urlParams.serverId &&
        state.urlParams.roleId
      );
    },
    hasFaqClassList(state) {
      return state.faqClassList.length > 0;
    },
    hasWorkTempList(state) {
      return state.workTempList.length > 0;
    }
  },
  mutations: {
    [SET_LANG](state, lang) {
      languages.setLanguage(lang);
      state.curLang = lang;
      state.languages = formatAdapter(languages.getAll());
      updateCommonParamsInfo({
        language: lang
      });
    },
    [SET_IS_LOGIN](state, bool) {
      state.isLogin = bool;
    },
    [SET_USER_INFO](state, data) {
      state.userInfo.gameName = data.gameName;
      state.userInfo.serverName = data.serverName;
      state.userInfo.roleName = data.roleName;
    },
    [SET_RECORD_BIND_EMAIL](state, email) {
      state.recordBindEmail = email;
    },
    [SET_WORK_TEMP_LIST](state, list) {
      state.workTempList = list;
    },
    [SET_FAQ_SITE_NAME](state, name) {
      state.faqSiteName = name;
    },
    [SET_FAQ_CLASS_LIST](state, list) {
      state.faqClassList = list;
    },
    [SET_FAQ_NOTICE](state, list) {
      state.faqNotice = list;
    },
    [SET_SUPPORT_LANG](state, list) {
      state.supportLang = list;
    },
    [SET_DEFAULT_LANG](state, lang) {
      state.defaultLang = lang;
    },
    [SET_JUMP_AIBOT](state, bool) {
      state.isJumpAiBot = bool;
    },
    [SET_LOGIN_ACCOUNT](state, loginAccount) {
      state.loginAccount = loginAccount;
    },
    [SET_IS_SPECIAL_DIFY_USER](state, isSpecialDifyUser) {
      state.isSpecialDifyUser = isSpecialDifyUser;
    },
    [SET_SHOW_UPDATE_VERSION_POPUP](state, bool) {
      state.showUpdateVersionPopup = bool;
    }
  },
  actions: {
    // 游戏列表：传入游戏ID只返回该游戏ID和名称，不传返回全部
    getGameList({ state }, gameId) {
      return new Promise((resolve, reject) => {
        get(`${SUPPORT_REQ_URL}/getGames`, {
          game_id: gameId,
          user_id_cross: state.urlParams.uid,
          login_account: state.urlParams.loginAccount,
          appLanguage: state.curLang,
          language: state.curLang
        }).then(({ errmsg, data }) => {
          errmsg === '' ? resolve(data) : reject(errmsg);
        });
      });
    },
    // 服务器列表
    getServerList({ state }, gameId) {
      return new Promise((resolve, reject) => {
        get(`${SUPPORT_REQ_URL}/getServersByGameId`, {
          game_id: gameId,
          zone: state.curLang,
          user_id_cross: state.urlParams.uid,
          login_account: state.urlParams.loginAccount,
          appLanguage: state.curLang,
          language: state.curLang
        }).then(({ errmsg, data }) => {
          errmsg === '' ? resolve(data) : reject(errmsg);
        });
      });
    },
    // 获取玩家角色名列表
    getCharName({ state }, payload) {
      let { gameId, serverId } = payload;
      let host = SUPPORT_REQ_URL;
      /**
       * 越南大掌柜（gameId:215）工单页接口特殊处理
       * 包括工单页在内，储值页和官网都更换了域名dcqvn.com需要进行兼容处理，
       * 默认使用的域名是/src/resource/utiles.js中UID_GAME_CONFIG的requestName，
       * 但该js中UID_GAME_CONFIG的requestName使用地方众多，且还有其它接口和链接用到，暂时这里先写死特殊处理
       */
      if (gameId === '215') {
        host = '//gsupport.dcqvn.com/index';
      }
      return new Promise((resolve, reject) => {
        get(`${host}/getCharName`, {
          game_id: gameId,
          server_id: serverId,
          zone: state.curLang,
          user_id_cross: state.urlParams.uid,
          login_account: state.urlParams.loginAccount,
          appLanguage: state.curLang,
          language: state.curLang
        }).then(({ errmsg, data }) => {
          errmsg === '' ? resolve(data) : reject(errmsg);
        });
      });
    },
    // 检查登陆态
    checkLogin({ state, commit }) {
      let host = PASSPORT_HOST;
      /**
       * 越南大掌柜（gameId:215）工单页接口特殊处理
       * 包括工单页在内，储值页和官网都更换了域名dcqvn.com需要进行兼容处理，
       * 默认使用的域名是/src/resource/utiles.js中UID_GAME_CONFIG的requestName，
       * 但该js中UID_GAME_CONFIG的requestName使用地方众多，且还有其它接口和链接用到，暂时这里先写死特殊处理
       */
      if (state.urlParams.gameId === '215') {
        host = '//gpassport.dcqvn.com/';
      }
      return new Promise((resolve, reject) => {
        get(`${host}${CHECK_LOGIN_ACTION}`, {
          user_id_cross: state.urlParams.uid,
          login_account: state.urlParams.loginAccount,
          appLanguage: state.curLang,
          language: state.curLang
        }).then(({ errmsg, data }) => {
          if (errmsg) {
            commit(SET_IS_LOGIN, false);
            reject(errmsg);
          } else {
            commit(SET_IS_LOGIN, true);
            commit(
              SET_LOGIN_ACCOUNT,
              data?.LOGIN_ACCOUNT || state.urlParams.loginAccount || ''
            );
            updateCommonParamsInfo({
              loginAccount:
                data?.LOGIN_ACCOUNT || state.urlParams.loginAccount || '',
              uid: data?.UID || state.urlParams.uid || ''
            });
            window.csorderDataLayer.push({
              eventName: 'login',
              eventType: data?.LOGIN_PATH || ''
            });
            resolve(data);
          }
        });
      });
    },
    // 获取玩家信息
    getUserInfo({ state, commit }) {
      return new Promise((resolve, reject) => {
        get(`${SUPPORT_REQ_URL}/getGameData`, {
          game_id: state.urlParams.gameId,
          server_id: state.urlParams.serverId,
          role_id: state.urlParams.roleId,
          zone: state.curLang,
          user_id_cross: state.urlParams.uid,
          login_account: state.urlParams.loginAccount,
          appLanguage: state.curLang,
          language: state.curLang,
          package_name: state.urlParams.packageName
        }).then(({ errmsg, data }) => {
          if (errmsg) {
            reject(errmsg);
          } else {
            const gameName = formatGameName(
              state.urlParams.gameId,
              data.gameName
            );
            const roleName = state.urlParams.roleName || data.charName;
            const serverName = data.serverName;
            commit(SET_USER_INFO, {
              gameName,
              serverName,
              roleName
            });
            resolve(data);
          }
          errmsg === '' ? resolve(data) : reject(errmsg);
        });
      });
    },
    // 工单列表
    getWorkList({ state }, params) {
      return new Promise((resolve, reject) => {
        get(
          `${SUPPORT_REQ_URL}/getOrderList`,
          Object.assign(
            {
              zone: state.curLang,
              gpid: state.urlParams.gpid,
              idfa: state.urlParams.idfa,
              e_info: state.urlParams.e_info,
              finger_print: getFingerprint(),
              user_id_cross: state.urlParams.uid,
              login_account: state.urlParams.loginAccount,
              game_id: state.urlParams.gameId,
              appLanguage: state.curLang,
              language: state.curLang
            },
            params
          )
        ).then(({ res }) => {
          if (res.result === 1) {
            resolve(res?.data);
          } else {
            Toast.fail(res?.data?.msg);
            reject(res?.data?.msg);
          }
        });
      });
    },
    // 工单详情
    getWorkDetail({ state }, workId) {
      return new Promise(resolve => {
        get(`${SUPPORT_REQ_URL}/getMessage`, {
          support_order_id: workId,
          gpid: state.urlParams.gpid,
          idfa: state.urlParams.idfa,
          e_info: state.urlParams.e_info,
          finger_print: getFingerprint(),
          user_id_cross: state.urlParams.uid,
          login_account: state.urlParams.loginAccount,
          appLanguage: state.curLang,
          language: state.curLang
        }).then(({ res }) => {
          if (res.result === 1) {
            // 获取工单信息
            resolve(res?.data);
          } else {
            Toast.fail(res?.data?.msg);
          }
        });
      });
    },
    // 提交工单
    createWork({ state }, params) {
      params.zone = state.curLang;
      params.gpid = state.urlParams.gpid;
      params.idfa = state.urlParams.idfa;
      params.e_info = state.urlParams.e_info;
      params.finger_print = getFingerprint();
      params.package_name = state.urlParams.packageName;
      params['user_id_cross'] = state.urlParams.uid;
      params['login_account'] = state.urlParams.loginAccount;
      params = Object.assign(
        {},
        globalConfig.getHrefParamObj(),
        { appLanguage: state.curLang, language: state.curLang },
        params
      );
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${SUPPORT_REQ_URL}/create_request`,
            qs.stringify(appendEntryPageParams(params), {
              arrayFormat: 'brackets'
            })
          )
          .then(res => {
            if (res?.data?.result == 1) {
              resolve(res?.data);
            } else {
              Toast.fail(res?.data?.msg);
              reject(res?.data?.msg);
            }
          });
      });
    },
    // 给客服发消息
    sendMessage({ state }, params) {
      params.zone = state.curLang;
      params.gpid = state.urlParams.gpid;
      params.idfa = state.urlParams.idfa;
      params.e_info = state.urlParams.e_info;
      params.finger_print = getFingerprint();
      params['user_id_cross'] = state.urlParams.uid;
      params['login_account'] = state.urlParams.loginAccount;
      params['appLanguage'] = state.curLang;
      params['language'] = state.curLang;
      return new Promise((resolve, reject) => {
        post(`${SUPPORT_REQ_URL}/message_request`, params).then(({ res }) => {
          if (res.result === 1) {
            // 发送客服信息
            resolve(res?.data);
          } else {
            // 错误提醒
            Toast.fail(res?.data?.msg);
            reject(res?.data?.msg);
          }
        });
      });
    },
    // 给客服评分
    evaluation({ state }, params) {
      params.zone = state.curLang;
      params.gpid = state.urlParams.gpid;
      params.idfa = state.urlParams.idfa;
      params.e_info = state.urlParams.e_info;
      params.finger_print = getFingerprint();
      params['user_id_cross'] = state.urlParams.uid;
      params['login_account'] = state.urlParams.loginAccount;
      params['appLanguage'] = state.curLang;
      params['language'] = state.curLang;
      return new Promise(resolve => {
        post(`${SUPPORT_REQ_URL}/evaluation_request`, params).then(
          ({ res }) => {
            if (res?.result !== 1) {
              Toast.fail(res?.data?.msg);
              reject();
            } else {
              resolve(res);
            }
          }
        );
      });
    },
    // 分片：上传图片
    fragmentationUploadImage(_context, file) {
      // 获取文件扩展名
      const fileExtension = getFileExtension(file);

      // 获取未上传切片记录
      const getUploadSliceRecord = async (context, chunks) => {
        let fd = new FormData();
        fd.append('context', context);
        fd.append('chunks', chunks.length);
        const response = await xhtPost(
          `${SUPPORT_REQ_URL}/getUnUploadChunks`,
          fd
        );
        return +response.result === 1 ? response.data?.UnUploadChunks : [];
      };

      return new Promise(async (resolve, reject) => {
        const LENGTH = 1024 * 1024 * 0.2; // 0.2M每个chunk
        const chunks = sliceFile(file, LENGTH);
        // 获取对于同一个文件，获取其的context
        const context = createContext(file);
        let record = null;
        try {
          record = await getUploadSliceRecord(context, chunks);
        } catch (error) {
          reject(error);
          return;
        }

        const tasks = [];
        chunks.forEach((chunk, index) => {
          // 已上传的切片则不再重新上传
          if (!record.includes(index + 1)) {
            return;
          }
          let fd = new FormData();
          fd.append('file', chunk);
          fd.append('context', context);
          fd.append('chunk', index + 1);
          fd.append('type', 'support_order');
          fd.append('e_info', globalConfig.getHrefParam('e_info'));
          fd.append('user_id_cross', globalConfig.getHrefParam('uid') || '');
          fd.append(
            'login_account',
            globalConfig.getHrefParam('loginAccount') || ''
          );

          tasks.push(
            xhtPost(`${SUPPORT_REQ_URL}/uploadImg2`, fd).then(res => {
              +res?.result && record.push(index);
            })
          );
        });
        // 所有切片上传完毕后，调用mkfile接口
        await Promise.all(tasks)
          .then(() => {
            let fd = new FormData();
            fd.append('context', context);
            fd.append('chunks', chunks.length);
            fd.append('file_ext', fileExtension);
            xhtPost(`${SUPPORT_REQ_URL}/mkFile`, fd).then(res => {
              let url = (res.data && res.data?.IMG_URL[0]) || '';
              if (res.result === 1) {
                resolve(url);
              } else {
                Toast(res?.msg);
                reject();
              }
            });
          })
          .catch(error => {
            console.error(error);
            reject();
          });
      });
    },
    // 分片：上传视频
    fragmentationUploadVideo({ state }, file) {
      // 获取未上传切片记录
      const getUploadSliceRecord = async (context, chunks) => {
        let fd = new FormData();
        fd.append('video_type', 'mp4');
        fd.append('chunks', chunks.length);
        fd.append('user_id_cross', state.urlParams.uid);
        fd.append('login_account', state.urlParams.loginAccount);
        const response = await xhtPost(
          `${SUPPORT_REQ_URL}/getUploadVideoUrls`,
          fd
        );
        return +response.result === 1 ? response?.data : {};
      };

      return new Promise(async (resolve, reject) => {
        const LENGTH = 1024 * 1024 * 5; // 5M每个chunk
        const chunks = sliceFile(file, LENGTH);
        // 获取对于同一个文件，获取其的context
        const context = createContext(file);
        let record = null;
        let uploadId = '';
        let filePath = '';
        try {
          const resData = await getUploadSliceRecord(context, chunks);
          record = resData.upload_urls;
          uploadId = resData.upload_id;
          filePath = resData.file_path;
        } catch (error) {
          reject(error);
          return;
        }

        const tasks = [];
        chunks.forEach((chunk, index) => {
          tasks.push(xhrPut(record[index], chunk));
        });
        // 所有切片上传完毕后，调用mkfile接口
        await Promise.all(tasks)
          .then(() => {
            let fd = new FormData();
            fd.append('uploadId', uploadId);
            fd.append('filePath', filePath);
            xhtPost(`${SUPPORT_REQ_URL}/competeUploadVideo`, fd).then(res => {
              if (res.result === 1) {
                resolve(filePath);
              } else {
                Toast(res?.msg);
                reject();
              }
            });
          })
          .catch(error => {
            console.error(error);
            reject();
          });
      });
    },
    // 绑定邮箱
    bindEmail({ state }, params) {
      return new Promise((resolve, reject) => {
        post(`${SUPPORT_REQ_URL}/bindEmail`, {
          e_info: state.urlParams.e_info,
          email: decodeURIComponent(encryption(params.email)),
          status: params.status,
          game_id: state.urlParams.gameId,
          role_id: state.urlParams.roleId,
          game_server_id: state.urlParams.serverId,
          appLanguage: state.curLang,
          language: state.curLang
        }).then(({ errmsg, data }) => {
          if (errmsg === '') {
            resolve(data);
          } else {
            Toast.fail(errmsg);
            reject(errmsg);
          }
        });
      });
    },
    // 获取邮箱
    getEmail({ state, commit }) {
      return new Promise((resolve, reject) => {
        post(`${SUPPORT_REQ_URL}/getEm`, {
          e_info: state.urlParams.e_info,
          appLanguage: state.curLang,
          language: state.curLang
        }).then(({ errmsg, data }) => {
          if (errmsg === '') {
            if (data?.status == 1) {
              const email = hex2bin(Base64.decode(data.info));
              commit(SET_RECORD_BIND_EMAIL, email);
              resolve({
                status: data.status,
                info: email
              });
            } else {
              commit(SET_RECORD_BIND_EMAIL, '');
              resolve(data);
            }
          } else {
            Toast.fail(errmsg);
            reject(errmsg);
          }
        });
      });
    },
    // 置顶或者取消置顶工单
    setOrderToTop({ state }, params) {
      return new Promise((resolve, reject) => {
        post(`${SUPPORT_REQ_URL}/setOrderToTop`, {
          order_id: params.orderId,
          is_top: params.isTop, // 1置顶，0取消置顶
          finger_print: getFingerprint(),
          appLanguage: state.curLang,
          language: state.curLang
        }).then(({ errmsg, data }) => {
          if (errmsg === '') {
            resolve(data);
          } else {
            Toast.fail(errmsg);
            reject(errmsg);
          }
        });
      });
    },
    // 删除工单
    deleteOrder({ state }, params) {
      return new Promise((resolve, reject) => {
        post(`${SUPPORT_REQ_URL}/deleteOrder`, {
          order_id: params.orderId,
          finger_print: getFingerprint(),
          appLanguage: state.curLang,
          language: state.curLang
        }).then(({ errmsg, data }) => {
          if (errmsg === '') {
            resolve(data);
          } else {
            Toast.fail(errmsg);
            reject(errmsg);
          }
        });
      });
    },
    // 弹窗公告
    getNoticePopupConfig({ state }, param) {
      return new Promise((resolve, reject) => {
        getJSON(
          `${SUPPORT_REQ_URL}/getAnnouncement`,
          Object.assign({}, param, {
            appLanguage: state.curLang,
            language: state.curLang
          })
        )
          .then(({ res }) => {
            if (res.result === 1) {
              resolve(res?.data);
            } else {
              reject(res?.msg);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 发送客服公告显示记录
    postShowNoticeRecord({ state }, param) {
      return new Promise((resolve, reject) => {
        getJSON(
          `${SUPPORT_REQ_URL}/triggerAnnouncement`,
          Object.assign({}, param, {
            appLanguage: state.curLang,
            language: state.curLang
          })
        ).then(({ res }) => {
          if (res.result === 1) {
            resolve(res?.data);
          } else {
            reject(res?.msg);
          }
        });
      });
    },
    // // 判断是否可以上传视频
    // canUploadVideo(_context, params) {
    //   return new Promise((resolve, reject) => {
    //     get(`${SUPPORT_REQ_URL}/isAbleToUploadVideo`).then(({ res }) => {
    //       console.log(res);
    //       resolve(+res?.result === 1);
    //     });
    //   });
    // }
    // 获取工单模板列表
    getWorkTempList({ state, commit }, isLangChange) {
      return new Promise((resolve, reject) => {
        if (!isLangChange && state.workTempList.length > 0) {
          resolve(state.workTempList);
          return;
        }
        get(`${SUPPORT_REQ_URL}/getSmartOrderCfgList`, {
          e_info: state.urlParams.e_info,
          game_id: state.urlParams.gameId,
          appLanguage: state.curLang,
          language: state.curLang
        }).then(({ res }) => {
          if (res.result === 1) {
            if (res?.data?.list && Array.isArray(res.data.list)) {
              // 账号删除送审表单不显示在前台入口
              const list = res.data.list.filter(item => +item.id !== 74);
              commit(SET_WORK_TEMP_LIST, list);
              resolve(list);
            } else {
              commit(SET_WORK_TEMP_LIST, []);
              resolve([]);
            }
          } else {
            commit(SET_WORK_TEMP_LIST, []);
            reject(res?.data?.msg);
          }
        });
      });
    },
    // 获取智能工单配置详情
    getWorkTempDetail({ state }, params) {
      return new Promise((resolve, reject) => {
        get(`${SUPPORT_REQ_URL}/getSmartOrderCfgDetail`, {
          e_info: state.urlParams.e_info,
          smartOrderCfgId: params.workTempId,
          appLanguage: state.curLang,
          language: state.curLang
        }).then(({ res }) => {
          if (res.result === 1) {
            resolve(res?.data || {});
          } else {
            reject(res?.msg);
          }
        });
      });
    },
    // 获取FAQ站点名称
    getFaqSiteName({ state, commit }) {
      return new Promise(resolve => {
        if (state.faqSiteName) {
          resolve(state.faqSiteName);
          return;
        }
        getJSON(`${HOME_HOST}website/getFaqWebsiteNameByGameId`, {
          gameId: state.urlParams.gameId,
          appLanguage: state.curLang,
          language: state.curLang
        }).then(({ res }) => {
          if (res.result === 1) {
            commit(SET_FAQ_SITE_NAME, res?.data?.enname || '');
            resolve(res?.data?.enname || '');
          } else {
            commit(SET_FAQ_SITE_NAME, '');
            resolve('');
          }
        });
      });
    },
    // 获取FAQ分类列表
    getFaqClassList({ state, commit, dispatch }, isLangChange) {
      return new Promise((resolve, reject) => {
        if (!state.faqSiteName) {
          resolve([]);
          return;
        }
        if (!isLangChange && state.faqClassList.length > 0) {
          resolve(state.faqClassList);
          return;
        }
        getJSON(`${HOME_HOST}website/getWebsiteConfig`, {
          name: state.faqSiteName,
          appLanguage: state.curLang,
          language: state.curLang
        }).then(({ res }) => {
          if (res.result === 1) {
            if (res?.data?.languageConfig?.length > 0) {
              const langText = languages.getLangText();
              const supportLang = {};
              res.data.languageConfig.forEach(item => {
                if (langText[item]) {
                  supportLang[item] = langText[item];
                }
              });
              commit(SET_SUPPORT_LANG, supportLang || {});
              commit(SET_DEFAULT_LANG, res?.data?.languageConfig[0] || '');
              if (!supportLang[state.curLang]) {
                commit(SET_LANG, res.data.languageConfig[0]);
                dispatch('getFaqClassList', true);
              }
            }
            const classInfo = res?.data?.faqConfig?.classInfo || [];
            let languageConfig = {};
            if (
              res?.data?.faqConfig?.languageConfig &&
              isJSON(res.data.faqConfig.languageConfig)
            ) {
              languageConfig = JSON.parse(res.data.faqConfig.languageConfig);
            }
            const iconConfig = res?.data?.faqConfig?.iconConfig || {};
            classInfo.forEach(item => {
              const { id } = item;
              item.text = languageConfig[id] || '';
              item.icon = iconConfig[id] || '';
              item.sub.forEach(subItem => {
                subItem.text = languageConfig[subItem.id] || '';
              });
            });
            commit(SET_FAQ_CLASS_LIST, classInfo);
            resolve();
          } else {
            commit(SET_FAQ_CLASS_LIST, []);
            resolve();
          }
        });
      });
    },
    // 根据FAQ分类获取文章列表
    getFaqClassArticleList({ state }, params) {
      return new Promise((resolve, reject) => {
        getJSON(`${HOME_HOST}website/getWebsiteContent`, {
          classId: params.classId,
          name: state.faqSiteName,
          appLanguage: state.curLang,
          language: state.curLang
        }).then(({ res }) => {
          if (res.result === 1) {
            resolve(res?.data?.articlesInfo || []);
          } else {
            reject([]);
          }
        });
      });
    },
    // 根据文章ID获取详情
    getFaqDetail({ state }, params) {
      return new Promise((resolve, reject) => {
        getJSON(`${HOME_HOST}website/getWebsiteArticleById`, {
          id: params.id,
          name: state.faqSiteName,
          appLanguage: state.curLang,
          language: state.curLang
        }).then(({ res }) => {
          if (res.result === 1) {
            resolve(res?.data?.detail || {});
          } else {
            reject({});
          }
        });
      });
    },
    // 走马灯文章列表
    getFaqNotice({ state, commit }) {
      return new Promise((resolve, reject) => {
        getJSON(`${HOME_HOST}website/getArticleTicker`, {
          name: state.faqSiteName,
          appLanguage: state.curLang,
          language: state.curLang
        }).then(({ res }) => {
          if (res.result === 1) {
            commit(SET_FAQ_NOTICE, res?.data?.articleList || []);
            resolve(res?.data?.articleList || []);
          } else {
            reject([]);
          }
        });
      });
    },
    // 文章搜索
    searchFaq({ state }, params) {
      return new Promise((resolve, reject) => {
        getJSON(`${HOME_HOST}website/getWebsiteArticle`, {
          name: state.faqSiteName,
          appLanguage: state.curLang,
          language: state.curLang,
          search: params.content,
          searchType: params.searchType
        }).then(({ res }) => {
          if (res.result === 1) {
            resolve(res?.data || {});
          } else {
            reject({});
          }
        });
      });
    },
    /**
     * 点赞or取消点赞
     * gameId: 游戏id，不能为空
     * roleId：角色id，不能为空
     * loginAccount: 玩家账号，不能为空
     * action: 点赞：LIKE，取消点赞：CANCEL_LIKE
     * likeType：点赞类型，，ARTICLE为文章点赞
     */
    doLikeAction(_context, params) {
      return new Promise((resolve, reject) => {
        getJSON(`${HOME_HOST}article/m_wikiLike`, params).then(({ res }) => {
          if (res.result === 1) {
            resolve(res?.data || {});
          } else {
            reject(res?.msg);
          }
        });
      });
    },
    /**
     * 角色点赞总数+是否已点赞接口
     * gameId: 游戏id，不能为空
     * roleId：角色id，不能为空
     * loginAccount: 玩家账号，不能为空
     */
    getCharLikeNum(_context, params) {
      return new Promise((resolve, reject) => {
        getJSON(`${HOME_HOST}article/m_getRoleLikeNum`, params).then(
          ({ res }) => {
            if (res.result === 1) {
              resolve(res?.data || {});
            } else {
              reject(res?.msg);
            }
          }
        );
      });
    },
    // 获取用户是否跳转AI客服
    checkJumpAiBot({ commit }, params) {
      return new Promise(resolve => {
        // tiktok渠道特殊处理，不跳转AI客服
        if (globalConfig.isTiktokMiniProgram()) {
          commit(SET_JUMP_AIBOT, false);
          resolve();
          return;
        }

        get(`//gsupport.${MAIN_HOST}/smartChat/isOpenAiEntrance`, params).then(
          ({ res }) => {
            if (!res) {
              commit(SET_JUMP_AIBOT, false);
              resolve();
              return;
            }
            const { data, result } = res;
            if (result === 1 && data) {
              commit(SET_JUMP_AIBOT, true);
              resolve();
            } else {
              commit(SET_JUMP_AIBOT, false);
              resolve();
            }
          }
        );
      });
    },
    submitAiOrder(_context, params) {
      return new Promise((resolve, reject) => {
        post(
          `//gsupport.${MAIN_HOST}/aiSubmitOrder/submitAiOrder`,
          params
        ).then(({ res }) => {
          resolve(res);
        });
      });
    },
    getIsIpKrOrJp(_context, params) {
      return new Promise(resolve => {
        get(`//gsupport.${MAIN_HOST}/index/isIpKrOrJp`, params).then(
          ({ res }) => {
            resolve(res);
          }
        );
      });
    },
    checkAccountPayInfo(_context, params) {
      return new Promise((resolve, reject) => {
        post(
          `//gsupport.${MAIN_HOST}/aiSubmitOrder/checkAccountPayInfo`,
          params
        ).then(({ res }) => {
          resolve(res);
        });
      });
    },
    logout(_context, params) {
      return new Promise(resolve => {
        getJSON(`//${PASSPORT_HOST}web_login/logout`, params).then(res => {
          resolve({
            result: parseInt(res.result, 10) === 1
          });
        });
      });
    },
    getGame({ state }, gameId) {
      return new Promise((resolve, reject) => {
        get(`${SUPPORT_REQ_URL}/getGame`, {
          game_id: gameId,
          user_id_cross: state.urlParams.uid,
          login_account: state.urlParams.loginAccount,
          appLanguage: state.curLang,
          language: state.curLang
        }).then(({ errmsg, data }) => {
          errmsg === '' ? resolve(data) : reject(errmsg);
        });
      });
    },
    // 调用 popupForm 接口
    callPopupForm(_context, params) {
      const chatId =
        globalConfig.getHrefParam('chatId') ||
        globalConfig.getHrefParam('chat_id');
      if (!chatId) {
        return Promise.resolve();
      }
      const requestParams = {
        chatId,
        orderId: params.orderId || '',
        game_id: params.gameId || '',
        workTempId: params.workTempId || '',
        workTempName: params.workTempName || '',
        isSubmit: params.isSubmit || 0
      };
      return new Promise((resolve, reject) => {
        getJSON(`//gsupport.${MAIN_HOST}/smartChat/popupForm`, requestParams)
          .then(() => {
            resolve();
          })
          .catch(error => {
            console.log('popupForm error:', error);
            reject(error);
          });
      });
    }
  },
  modules: {
    sdkSkin
  }
};
